import { render, staticRenderFns } from "./PatientInsurancesRep.vue?vue&type=template&id=71ab9c8e&"
import script from "./PatientInsurancesRep.vue?vue&type=script&lang=js&"
export * from "./PatientInsurancesRep.vue?vue&type=script&lang=js&"
import style0 from "./PatientInsurancesRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports